// extracted by mini-css-extract-plugin
export default {"container":"AssignmentsList_container__uxFp8"};